import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Filtering from "../RuleCatalogue/Filtering";
import KpiCard from "../RuleCatalogue/KpiCard";
import Tables from "../RuleCatalogue/Tables";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import heartLoading from "../../assests/heartLoading.gif";

const RuleCatalogue = ({
  productId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [page, setPage] = useState(1);
  const [ruleData, setRuleData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [columnFilters, setColumnFilters] = useState({});

  const handleColumnFiltersChange = (filters) => {
    setColumnFilters(filters);
  };
    const capitalize = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);

  const getProductName = () => {
    try {
      const name = localStorage.getItem("selectedProductName");
      if (name && name.trim()) {
        return name
          .trim()
          .replace(/[^a-zA-Z0-9\s-_]/g, "")
          .replace(/\s+/g, "_");
      }
    } catch (error) {
      console.warn("Error reading product name:", error);
    }
    return "Product";
  };

  const getTimestamp = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const h = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const s = String(now.getSeconds()).padStart(2, "0");
    return `${y}${m}${d}_${h}${min}${s}`;
  };

  const exportToExcel = (data) => {
    if (!data || data.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rules");

    const filename = `${getProductName()}_${getTimestamp()}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, filename);
  };

 const handleExport = () => {
  if (!productId) return;

  axios
    .get(`${BASE_URL}/rule-catalouge-results`, {
      params: {
        product_id: productId,
        filters: currentFilters,
        searchTerm,
        page: 1,
        pageSize: 10000,
      },
    })
    .then((res) => {
      exportToExcel(res.data.tableData || []);
    })
    .catch((err) => console.error("Error exporting full data:", err));
};



const buildQueryString = () => {
  const query = [];

  if (productId) query.push(`product_id=${productId}`);

  query.push(`page=${page}`);
  query.push(`page_size=10`);
  
if (searchTerm && searchTerm.trim() !== "") {
  query.push(`search_term=${searchTerm}`);
}


  Object.entries(currentFilters).forEach(([key, value]) => {
    if (!value) return;

    const mappedKey = capitalize(key); 

    if (Array.isArray(value)) {
      value.forEach((v) => query.push(`filter=${mappedKey}=${v}`));
    } else {
      query.push(`filter=${mappedKey}=${value}`);
    }
  });

  Object.entries(columnFilters).forEach(([colKey, colVal]) => {
    if (!colVal) return;
    query.push(`column_search=${colKey}=${colVal}`);
  });

  return query.join("&");
};

  
  useEffect(() => {
    if (!productId) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const queryString = buildQueryString();
        const url = `${BASE_URL}/rule-catalouge-results?${queryString}`;

        const res = await axios.get(url);
        setRuleData(res.data);
      } catch (err) {
        console.error("Error fetching rule catalogue:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    currentFilters,
    searchTerm,
    page,
    productId,
    columnFilters,
    BASE_URL,
  ]);

  useEffect(() => {
    setPage(1);
  }, [searchTerm, currentFilters]);

  const handlePageChange = (p) => {
    setLoading(true);
    setPage(p);
  };



  if (!ruleData) {
    return (
      <div className="relative bg-white flex items-center justify-center z-50 h-[80vh]">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..."  width={200} />
          <span className="text-gray-700 text-[20px] text-center">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="rule-catalogue">
      <Filtering
                      productId={productId}
        availableFilters={ruleData.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        showSearch={true}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
      />

      <KpiCard rules={ruleData.rules} />

      <Tables
        tableData={ruleData.tableData}
        pagination={ruleData.pagination}
        onPageChange={handlePageChange}
        onExport={handleExport}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        loading={loading}
        onColumnFiltersChange={handleColumnFiltersChange}
      />
    </div>
  );
};

export default RuleCatalogue;
